import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
  // mode: 'history', // 去掉#，需要路由模式改为history
  // base: '/dist/', // 这个配置也很重要，否则会出现页面空白情况
  routes: [{
      path: '/',
      name: 'Index',
      component: () => import('../components/Index'),
    },
    {
      path: '/Details',
      name: 'Details',
      component: () => import('../components/Details'),
    },
    {
      path: '/Notice',
      name: 'Notice',
      component: () => import('../components/Notice'),
    },
    {
      path: '/NoticeDetails',
      name: 'NoticeDetails',
      component: () => import('../components/NoticeDetails'),
    },
    {
      path: '/layout',
      name: 'layout',
      component: () => import('../components/Layout'),
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: () => import('../components/Contactus'),
    },
    {
      path: '/Aboutus',
      name: 'Aboutus',
      component: () => import('../components/Aboutus'),
    },
    {
      path: '/Appdownload',
      name: 'Appdownload',
      component: () => import('../components/Appdownload'),
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: () => import('../components/introduce'),
    },
    {
      path: '/Qrcode',
      name: 'Qrcode',
      component: () => import('../components/Qrcode'),
    },
    {
      path: '/Application',
      name: 'Application',
      component: () => import('../components/Application'),
    },
    {
      path: '/Conpany',
      name: 'Conpany',
      component: () => import('../components/Conpany'),
    },
    {
      path: '/Privacy',
      name: 'Privacy',
      component: () => import('../components/Privacy'),
    },
    {
      path:'/activity/autumnOct/index',
      name:'autumnOctPC',
      component: () => import('../components/activity/autumnOct/index'),
    },
    {
      path:'/activity/autumnOct/wap',
      name:'autumnOctWap',
      component: () => import('../components/activity/autumnOct/wap'),
    },
  ]
});